import { PermissionT } from "../types";

export const sunnovaCertified = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "sunnova_submit");
  return !!p;
};

export default sunnovaCertified;
